import { Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from '../../../i18n/use-translation';
import { Button } from '../../atoms/button';
import { SmallPreloader } from '../../atoms/preloaders/smal_preloader';
import { Size } from '../../enums/size';
import { File } from '../../molecules/File';
import { Input } from '../../molecules/Input';
import { Textarea } from '../../molecules/Textarea';
import * as styles from './feedback_form.module.sass';
import { useViewModel } from './hook/use-view-model';
import { FeedbackFormProps } from './porps.type';
import { getDefaultValue } from './res/default-value';
import { getValidationForGuest, getValidationForUser } from './res/validation';

export const FeedbackForm = (props: FeedbackFormProps) => {
  const { t } = useTranslation();
  const { formSubmitHandler, isLoading, user } = useViewModel();

  return (
    <Formik
      // @ts-ignore
      initialValues={{ ...getDefaultValue(user) }}
      validationSchema={user ? getValidationForUser(t) : getValidationForGuest(t)}
      onSubmit={formSubmitHandler}
    >
      <Form>
        {!user && (
          <>
            <Input name="fullName" label={t('full_name')} placeholder={t('full_name')} required />
            <Input name="email" type="text" label={t('email')} placeholder={t('email')} required />
            <Input
                name="phone"
                type="text"
                label={t('phone_validation')}
                placeholder={'+380999999999'}
                mask="+380999999999"
                required
            />
          </>
        )}

        <Textarea name="description" label={t('feedback.description')} required />

        <File name="file" label={t('add_file_text')} inputClassName={styles.file_input} />

        <div className={styles.hint_wrapper}>
          <sup className={styles.error_icon}>٭</sup>
          <span className={styles.error_hint}> - {t('required_field')}</span>
        </div>

        {isLoading ? <SmallPreloader /> : <Button type="submit" text={t('feedback_in_button')} size={Size.BIG} />}
      </Form>
    </Formik>
  );
};
